import { CoverpathTermQuote } from '../../../../../../coverpath-common/classes/quote/coverpath/CoverpathTermQuote';
import { CoverpathUtils } from '../../../../../../coverpath-common/js/static/CoverpathUtils';
import { QuoteService } from '../../../../../../coverpath-common/angular/services/quote/quote.service';
import { Component } from '@angular/core';
import { QuickQuoteService } from './../../../services/quote/quick-quote.service';
import { ValidationService } from '../../../../../../coverpath-common/angular/services/validation/validation.service';
import { AmorphicService } from '../../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { ApplicationService } from '../../../../../../coverpath-common/angular/services/application/application.service';
import { Router } from '@angular/router';
import { BaseQuickQuoteComponent } from '../../../../../../coverpath-common/angular/components/quote/quick-quote/base-quick-quote.component';
import { RateClasses } from '../../../../../../common/js/static/RateClasses';
import { QuoteForm } from '../../../../../../coverpath-agent/public/js/components/home-new/quote-or-apply-new/QuoteForm';
import { FormBuilderService } from '../../../../../../coverpath-agent/public/js/components/home-new/quote-or-apply-new/form-builder.service';

@Component({
  selector: 'quick-quote',
  moduleId: module.id,
  templateUrl: './quick-quote.component.html',
})
export class QuickQuoteComponent extends BaseQuickQuoteComponent {
  nbDecommissionPost30Days: boolean;
  constructor(
    private quoteServiceInstance: QuoteService,
    private quickQuoteServiceInstance: QuickQuoteService,
    private validationServiceInstance: ValidationService,
    private applicationServiceInstance: ApplicationService,
    private amorphicServiceInstance: AmorphicService,
    private routerInstance: Router,
    private formBuilder: FormBuilderService
  ) {
    super(
      quoteServiceInstance,
      quickQuoteServiceInstance,
      validationServiceInstance,
      applicationServiceInstance,
      amorphicServiceInstance,
      routerInstance
    );
  }

  async ngOnInit(): Promise<void> {
    super.ngOnInit();
    this.nbDecommissionPost30Days = this.controller.nbDecommissionPost30Days;
    if (!this.nbDecommissionPost30Days) {
      this.loadQuickQuote();
      this.quickQuoteServiceInstance.triggerQuickQuoteLoad.subscribe(() => {
        this.loadQuickQuote();
      });
      if (this.controller.quickQuoteForm) {
        this.quickQuoteServiceInstance.clearQuickQuoteForm();
      }
    }
  }

  calculateHealthClass(): void {
    const quote = this.quickQuoteServiceInstance.getCurrentQuote() as CoverpathTermQuote;
    quote.healthClass = CoverpathUtils.getRateClassStringCode(quote.healthClassNumber, quote.smoker);
    this.setQuoteProperties(quote);
  }

  async loadQuickQuote(): Promise<void> {
    let isUpdate = false;
    let quote = this.quickQuoteServiceInstance.getCurrentQuote() as CoverpathTermQuote;
    //Check if latest quote is of type CoverpathTermQuote;
    if (this.quickQuoteServiceInstance.isCoverpathTermQuote(quote) && quote.isAdvisorQuote) {
      // Make copy of Agent -> Client quote and unshift onto insuranceQuotes
      this.quickQuoteServiceInstance.setNewCoverpathClientQuote();
      quote = this.quickQuoteServiceInstance.getCurrentQuote() as CoverpathTermQuote;
      isUpdate = true;
    }
    const clientQuote = quote as CoverpathTermQuote;
    this.initializeProperties();
    this.validateEligibilityForWaiverOfPremium();
    if (this.controller.customer.termQuote) {
      this.validateEligibilityForExtendedConvertibility();
    }
    this.setQuoteProperties(clientQuote);
    await this.attemptQuoteFetch();
    if (isUpdate) {
      this.updateAllViewChildren();
    }

    // loadQuickQuote can be called multiple times, so only adding the NY options
    // if doesn't already exist in the options list
    const isNYinOptions = this.stateInput.options.find((state) => state.value === 'NY');
    const isCoverpathNYEnabled = this.controller.isCoverpathNYEnabled;
    if (isCoverpathNYEnabled && !isNYinOptions) {
      const nyOption = { value: 'NY', description: 'New York' };
      this.stateInput.options.push(nyOption);
      this.stateInput.options.sort((a, b) => (a.description > b.description ? 1 : -1));
    }
  }

  initializeProperties(): void {
    const quote = this.quickQuoteServiceInstance.getCurrentQuote() as CoverpathTermQuote;
    quote.gender = quote.gender || '1'; //Male
    quote.dateOfBirth = quote.dateOfBirth || new Date('January, 1 1983');
    quote.smoker = quote.smoker || false;
    quote.contractState = quote.contractState || 'MA';
    quote.term = quote.term || 20;
    quote.faceAmount = quote.faceAmount || 100000;
    quote.healthClass = quote.healthClass || RateClasses.ULTRA.stringCode;
    quote.waiverOfPremium = quote.waiverOfPremium || false;
    quote.waiverOfPremiumAmount = quote.waiverOfPremiumAmount || 0;
    quote.carrierCode = quote.carrierCode || 'CAS';
    quote.isAgentAssistant = quote.isAgentAssistant || false;
    quote.hasEcp = quote.hasEcp || false;
  }

  applyNow(): void {
    if (!this.quickQuoteServiceInstance.hasAssociatedAgent()) {
      this.routerInstance.navigate(['help']);
    } else {
      this.quickQuoteServiceInstance.setQuickQuoteForm(this.generateQuoteForm());
      this.quickQuoteServiceInstance.setCustomerQuote();
      CoverpathUtils.dataLayerPush({
        event: 'gtm-event-client_get-quote',
      });
      this.quickQuoteServiceInstance.routeCustomer();
    }
  }

  // Form data object used to create an additional generic link app.
  private generateQuoteForm(): QuoteForm {
    const quote = this.quickQuoteServiceInstance.getCurrentQuote() as CoverpathTermQuote;
    const policy = this.controller.customer.application.primaryPolicy;
    const quoteForm: QuoteForm = this.formBuilder.createForm().value;
    quoteForm.producerId = policy.primaryPolicyAgent.agent.producerId;
    quoteForm.productType = 'Term';
    quoteForm.termQuote.faceAmount = quote.faceAmount;
    quoteForm.termQuote.coverageTerm = quote.term;
    quoteForm.termQuote.waiverOfPremium = quote.waiverOfPremium;
    quoteForm.termQuote.waiver = quote.waiverOfPremiumAmount;
    quoteForm.clientInformation.ownerEqualsInsured = true;
    quoteForm.clientInformation.gender = quote.gender;
    quoteForm.clientInformation.dob = quote.dateOfBirth;
    quoteForm.clientInformation.healthClass = quote.healthClass;
    quoteForm.clientInformation.contractState = quote.contractState;
    return quoteForm;
  }
}
